export default __webpack_public_path__ + "static/media/CHEAPESTPRICE.8c1db9ca.png";